(() => {
  function initialize() {
    document.querySelectorAll('.blog__article').forEach(article => {
      const body = article.querySelector('.blog__article__content');
      const toc = article.querySelector('[data-page-toc]');
      if (!body || !toc || toc.dataset.ready) return;
      if (article.closest('.bioku-magazine')) {
        body.querySelectorAll('h2,h3').forEach(heading => {
          if (!/^[【〔\[]?材料(?:[】〕\]]|[（(\s]|$)/.test(heading.textContent.trim())) return;
          const list = heading.nextElementSibling;
          if (!list || !['UL','TABLE'].includes(list.tagName) || heading.closest('.bioku-article-materials,.bioku-recipe-materials')) return;
          const section = document.createElement('section');
          section.className = 'bioku-article-materials';
          heading.before(section); section.append(heading,list);
        });
      }
      const headings = [...body.querySelectorAll('h2,h3')].filter(h => h.textContent.trim());
      if (headings.length < 2 || body.querySelector('.bioku-recipe-jump')) return;
      const list = toc.querySelector('ol');
      headings.forEach((heading,index) => {
        if (!heading.id) heading.id = `bioku-reading-${index+1}`;
        const li=document.createElement('li'),link=document.createElement('a');
        link.href = `#${heading.id}`; link.textContent = heading.textContent.trim();
        li.append(link);list.append(li);
      });
      toc.hidden=false;toc.dataset.ready='true';
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize);else initialize();
  document.addEventListener('shopify:section:load',initialize);
})();
